import { defineComponent as w, createElementBlock as r, createCommentVNode as l, openBlock as i, Fragment as I, withModifiers as a, normalizeClass as d, createTextVNode as C, createBlock as s, toDisplayString as m, capitalize as u, unref as n, withCtx as k, createVNode as h, createElementVNode as p } from "vue";
import { ScalarButton as v } from "@scalar/components";
import { ScalarIconEye as y, ScalarIconPencil as f } from "@scalar/icons";
const $ = ["href"], E = ["href"], M = /* @__PURE__ */ w({
  __name: "HeaderItemTab",
  props: {
    tab: {},
    isEditable: { type: Boolean },
    isMobile: { type: Boolean },
    linkIsActive: { type: Function },
    resolveInternalLinks: { type: Function }
  },
  emits: ["navigate", "toggleShow", "editOpenAPIDocument"],
  setup(S, { emit: g }) {
    const b = g;
    return (e, t) => e.tab.show || e.isEditable ? (i(), r(I, { key: 0 }, [
      e.isMobile ? (i(), r("a", {
        key: 0,
        class: d(["header-item-link", {
          "header-item-active": e.linkIsActive(e.tab),
          "header-item-ghost": !e.tab.show
        }]),
        href: e.resolveInternalLinks(e.tab),
        onClick: t[2] || (t[2] = a((o) => e.$emit("navigate", e.tab.uid, e.tab.type), ["prevent"]))
      }, [
        C(m(e.tab.title || u(e.tab.type)) + " ", 1),
        !e.tab.show && e.isEditable ? (i(), s(n(v), {
          key: 0,
          class: "header-item-show-button",
          variant: "ghost",
          onClick: t[0] || (t[0] = a((o) => e.$emit("toggleShow", e.tab.uid, e.tab.type), ["stop"]))
        }, {
          default: k(() => [
            h(n(y)),
            t[6] || (t[6] = p("span", null, "Show", -1))
          ]),
          _: 1,
          __: [6]
        })) : l("", !0),
        e.isEditable && e.tab.type === "reference" ? (i(), s(n(f), {
          key: 1,
          weight: "fill",
          onClick: t[1] || (t[1] = a((o) => b("editOpenAPIDocument"), ["stop"]))
        })) : l("", !0)
      ], 10, $)) : (i(), r("a", {
        key: 1,
        class: d(["header-item-link", {
          "header-item-active": e.linkIsActive(e.tab),
          "header-item-ghost": !e.tab.show
        }]),
        href: e.resolveInternalLinks(e.tab),
        onClick: t[5] || (t[5] = a((o) => e.$emit("navigate", e.tab.uid, e.tab.type), ["prevent"]))
      }, [
        p("span", null, m(e.tab.title || u(e.tab.type)), 1),
        !e.tab.show && e.isEditable ? (i(), s(n(v), {
          key: 0,
          class: "header-item-show-button",
          variant: "ghost",
          onClick: t[3] || (t[3] = a((o) => e.$emit("toggleShow", e.tab.uid, e.tab.type), ["stop"]))
        }, {
          default: k(() => [
            h(n(y), { weight: "fill" }),
            t[7] || (t[7] = p("span", null, "Show", -1))
          ]),
          _: 1,
          __: [7]
        })) : l("", !0),
        e.isEditable && e.tab.type === "reference" && e.tab.hasManagedDoc ? (i(), s(n(f), {
          key: 1,
          weight: "fill",
          onClick: t[4] || (t[4] = a((o) => b("editOpenAPIDocument"), ["stop"]))
        })) : l("", !0)
      ], 10, E))
    ], 64)) : l("", !0);
  }
});
export {
  M as default
};
